import React from 'react';

import AnimatedBlobBackground from '../../components/common/backgrounds/AnimatedBlobBackground';

export default function About() {
  const sections = [
    { selector: '#about', imagePosition: 'left' },
    { selector: '#services', imagePosition: 'center' },
    { selector: '#visionMission', imagePosition: 'right' },
  ];
  return (
    <div>
      {/* Animated Blob Background */}
      <AnimatedBlobBackground sections={sections} />

      {/* About section start */}
      <section className="" id="about">
        <div className="container mx-auto flex items-center">
          <div className="grid sm:grid-cols-2 grid-cols-1">
            <div className="col-span-1">
              <div className="sm:mb-0 mb-6">
                <img src="/assets/images/about/about-banner.png" alt="Home Banner" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="flex justify-center items-center h-full">
                <div className="sm:text-left text-center">
                  <span className="subheading">Who are we</span>
                  <h1 className="mt-2">Where Learning Meets Guidance</h1>
                  <p className="mt-5">
                    Evening School is a learning haven for all ages where curiosity meets guidance,
                    strengths are discovered, and dreams take shape after dark.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About section end */}

      {/* Service section start */}
      <section className="sm:mt-10 mt-20" id="services">
        <div className="container mx-auto flex items-center">
          <div className="grid sm:grid-cols-2 grid-cols-1">
            <div className="col-span-1">
              <div className="flex justify-center items-center h-full">
                <div className="sm:text-left text-center">
                  <span className="subheading">What we are doing</span>
                  <h2 className="mt-2">
                    Connecting Teachers
                    <br />
                    with Learners
                  </h2>
                  <p className="mt-5">
                    We deliver personalized evening learning that identifies each student’s
                    strengths, builds on their passions, and guides them step by step toward their
                    goals.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-span-1 sm:order-last order-first">
              <div className="sm:mb-0 mb-6">
                <img src="/assets/images/about/what-we-are-image.png" alt="Home Banner" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Service section end */}

      {/* Vision and Mission section start */}
      <section className="sm:mt-10 mt-20 mb-10" id="visionMission">
        <div className="container w-[80%] mx-auto flex items-center">
          <div className="grid sm:grid-cols-2 grid-cols-1 gap-10">
            <div className="col-span-1">
              <div className="glass-card text-center">
                <img
                  className="w-[75px] mx-auto"
                  src="/assets/images/icons/startup.png"
                  alt="Card Icon"
                />
                <h3 className="text-2xl font-semibold mt-5">Our Vision</h3>
                <p className="mt-3">
                  To guide every learner any age, any background toward their goals with
                  personalized evening education
                </p>
              </div>
            </div>
            <div className="col-span-1">
              <div className="glass-card text-center">
                <img
                  className="w-[75px] mx-auto"
                  src="/assets/images/icons/compass.png"
                  alt="Card Icon"
                />
                <h3 className="text-2xl font-semibold mt-5">Our mission</h3>
                <p className="mt-3">
                  Empowering students of all ages through personalized evening learning, uncovering
                  strengths, nurturing passions, and turning goals into achievements
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Vision and Mission section end */}
    </div>
  );
}
